module.exports = __webpack_public_path__ + "static/assets/7989ed479fde1dc33973207f24917615.svg";